(function($) {

$('.about__calendar__container').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  vertical: true,
  arrows: true,
  dots: false,
  adaptiveHeight: false,
  draggable: true,
  variableWidth: false,
  autoplay: false,
  fade: false,
  autoplaySpeed: 2500,

  responsive: [
    {
      breakpoint: 1024,
      settings: "unslick"
    }
  ]
});





$('.images_slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  adaptiveHeight: false,
  variableWidth: false,
  autoplay: true,
  fade: false,
  autoplaySpeed: 2500
});

$('.media__container').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  adaptiveHeight: false,
  variableWidth: false,
  autoplay: false,
  fade: false,
  autoplaySpeed: 2500,
  responsive: [
    {
      breakpoint: 930,
      settings: {
        dots: true,
        arrows: false,
        adaptiveHeight: true
      }
    }
  ]
});

document.addEventListener('malinkyLoadPostsComplete', function(e) {
  console.log('LoadPostsComplete');
  $('.reveal-news').foundation();
});


// Scroll navigation bar
window.scrollNav=function() {
  $('.menu a').click(function(){  
    $(".active").removeClass("active");      
    $(this).addClass("active");
    $('html, body').stop().animate({
        scrollTop: $( $(this).attr('href') ).offset().top
    }, 400);
    return false;
  });
}

scrollNav();


})(jQuery);
